import { InstrumentFrame } from "./frames";

export default function LandingGearControls(k, x) {
    InstrumentFrame(k, "L. GEAR", x, k.height() - 5, 50, 115);
};